<template>
  <div class="render-ticket">
    <p class="event-ticket event-name">{{ eventName }}</p>
    <img v-if="eventImage !== null" class="event-logo" :src="eventImage" />
    <div v-if="eventShowQrcode">
      <canvas class="qrcode" ref="canvas"></canvas>
    </div>
    <p class="event-ticket event-location">
      <icon name="map-marker"></icon>
      {{ eventLocation }}
    </p>
    <p class="event-ticket event-date">
      <icon name="calendar"></icon>
      {{ eventDate | date }}
    </p>
    <p class="event-ticket ticket-name">{{ ticketTypeName }}</p>
    <p class="event-ticket ticket-value" v-if="ticketTypeValue">{{ ticketTypeValue | currency }}</p>
    <p class="event-ticket event-note">{{ eventNote }}</p>
    <p class="event-ticket sale-number">
      <icon name="ticket-alt" scale="0.8"></icon>
      {{ ticketNumber }}
    </p>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'Ticket',
  props: [
    'eventName',
    'eventImage',
    'eventLocation',
    'eventDate',
    'eventNote',
    'eventShowQrcode',
    'ticketTypeName',
    'ticketTypeValue',
    'ticketNumber',
    'ticketCode'
  ],
  data () {
    return {
    }
  },
  mounted () {
    this.handleQrcode()
  },
  updated () {
    this.handleQrcode()
  },
  methods: {
    handleQrcode () {
      let code = this.ticketCode ? this.ticketCode : '8eb90ec152bd30f4a53f15bf805783dc'
      let canvas = this.$refs.canvas
      let opt = { errorCorrectionLevel: 'H' }
      QRCode.toCanvas(canvas, code, opt, function (error) {
        if (error) console.error(error)
      })
    }
  }
}
</script>
